// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__3Ayhl","notes":"Notes_notes__10V8o"};